// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '52b6c9bc-20be-4667-9360-873ea0dce124',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: -47,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Island_5',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'FUN FAIR',
        atlas: 'diorama_5',
        reward: {
          'Coin': 100,
          'BoosterRedraw': 1,
        }
      }
    },
    {
      id: 'f65cec6a-50d5-4804-93d3-e6fedd8cfd9a',
      type: 'Sprite',
      name: 'balloonShopShadow',
      className: '',
      x: -136,
      y: -119,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Balloon_Shop_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0da23a5c-2582-4b6f-a85f-cc3894185f10',
      type: 'Sprite',
      name: 'balloonShop',
      className: '',
      x: -153,
      y: -173,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Balloon_Shop',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1500,
        order: 5
      }
    },
    {
      id: '3c41c025-193c-49cb-b5ba-ee9e138ec955',
      type: 'Sprite',
      name: 'carrouselShadow',
      className: '',
      x: -74,
      y: -416,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Carrousel_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '541c1c5c-1d1a-42e5-914d-61e0b81c1e0b',
      type: 'Sprite',
      name: 'carrousel',
      className: '',
      x: -85,
      y: -456,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Carrousel',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1500,
        order: 3
      }
    },
    {
      id: '346c685d-36dc-4acc-8080-43e436fbb6ba',
      type: 'Sprite',
      name: 'wheelShadow',
      className: '',
      x: 181,
      y: -381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Ferris_Wheel_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'b73f3666-5520-4b14-8a37-c4db36a33112',
      type: 'Sprite',
      name: 'wheel',
      className: '',
      x: 182,
      y: -476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Ferris_Wheel',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 1
      }
    },
    {
      id: '287b1df8-1c67-4895-9805-0836bde7acf7',
      type: 'Sprite',
      name: 'coasterShadow',
      className: '',
      x: 65,
      y: -119,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Roller_Coaster_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '5da07c2b-afdf-4c8f-ba35-f303a885af8b',
      type: 'Sprite',
      name: 'coaster',
      className: '',
      x: 39,
      y: -198,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Roller_Coaster',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2000,
        order: 6
      }
    },
    {
      id: '40f23ade-7326-4de9-b1db-896e5ac5a373',
      type: 'Sprite',
      name: 'iceCreamShopShadow',
      className: '',
      x: -170,
      y: -268,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Ice_Cream_Shop_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0199ed88-1a78-4c43-b805-67b6d6560854',
      type: 'Sprite',
      name: 'iceCreamShop',
      className: '',
      x: -181,
      y: -324,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Ice_Cream_Shop',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1500,
        order: 4
      }
    },
    {
      id: '5738cfe3-42dd-42f9-bbfe-f2e18d8ea88d',
      type: 'Sprite',
      name: 'clownShadow',
      className: '',
      x: 30,
      y: -469,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Clown_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '79694f9f-2835-4dd6-b940-c6e1fd945c9b',
      type: 'Sprite',
      name: 'clown',
      className: '',
      x: 24,
      y: -514,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_5_Clown',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 2
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_5 {
  static raw = raw;
  root!: Container;
  island!: Sprite & { data: typeof raw['list'][1]['data'] };
  balloonShopShadow!: Sprite;
  balloonShop!: Sprite & { data: typeof raw['list'][3]['data'] };
  carrouselShadow!: Sprite;
  carrousel!: Sprite & { data: typeof raw['list'][5]['data'] };
  wheelShadow!: Sprite;
  wheel!: Sprite & { data: typeof raw['list'][7]['data'] };
  coasterShadow!: Sprite;
  coaster!: Sprite & { data: typeof raw['list'][9]['data'] };
  iceCreamShopShadow!: Sprite;
  iceCreamShop!: Sprite & { data: typeof raw['list'][11]['data'] };
  clownShadow!: Sprite;
  clown!: Sprite & { data: typeof raw['list'][13]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
